export default {
  // Navigation Tabs & Menus
  tabs: {
    home: 'الرئيسية',
    services: 'الخدمات',
    orders: 'الطلبات',
    wallet: 'المحفظة',
    profile: 'حسابي',
  },

  nav: {
    dashboard: 'لوحة التحكم',
    new_order: 'طلب جديد',
    services: 'الخدمات',
    orders: 'الطلبات',
    deposit: 'شحن الرصيد',
    virtual_numbers: 'أرقام وهمية',
    referrals: 'برنامج الإحالة',
    settings: 'الإعدادات',
    support: 'الدعم الفني',
    guide: 'دليل الاستخدام',
    logout: 'تسجيل الخروج',
    login: 'تسجيل الدخول',
    signup: 'إنشاء حساب',
    features: 'المميزات',
    platforms: 'المنصات',
    how_it_works: 'كيف يعمل',
    pricing: 'الأسعار',
    faq: 'الأسئلة الشائعة',
    language: 'اللغة',
  },

  // Common UI
  common: {
    loading: 'جارٍ التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    back: 'رجوع',
    submit: 'إرسال',
    copied: 'تم النسخ إلى الحافظة',
    search: 'بحث...',
    all: 'الكل',
    completed: 'مكتمل',
    pending: 'قيد الانتظار',
    in_progress: 'قيد التنفيذ',
    failed: 'فشل',
    cancelled: 'ملغي',
    partial: 'جزئي',
    see_all: 'عرض الكل',
    details: 'التفاصيل',
    status: 'الحالة',
    close: 'إغلاق',
    try_again: 'إعادة المحاولة',
    error: 'خطأ',
    success: 'نجاح',
    something_went_wrong: 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
    rate_per_1k: 'السعر لكل 1,000',
    min_max: 'الحد الأدنى / الأقصى',
    action: 'إجراء',
    actions: 'إجراءات',
    category: 'الفئة',
    service: 'الخدمة',
    quantity: 'الكمية',
    link: 'الرابط / اسم المستخدم',
    cost: 'التكلفة',
    total_cost: 'التكلفة الإجمالية',
    date: 'التاريخ',
    order: 'الطلب',
    refresh: 'تحديث',
    delivery_time: 'وقت البدء والتنفيذ',
    available_balance: 'الرصيد المتاح',
    add_funds: 'شحن الرصيد',
    place_order: 'إنشاء الطلب',
  },

  // Auth Screens
  auth: {
    welcome_title: 'نمِّ حساباتك على وسائل التواصل',
    welcome_sub: 'المنصة الأسرع والأكثر موثوقية لخدمات السوشيال ميديا للمبدعين والشركات.',
    login: 'تسجيل الدخول',
    sign_up: 'إنشاء حساب',
    sign_in: 'دخول',
    email_or_username: 'البريد الإلكتروني أو اسم المستخدم',
    password: 'كلمة المرور',
    remember_me: 'تذكرني',
    forgot_password: 'هل نسيت كلمة المرور؟',
    or_continue_with: 'أو المتابعة عبر',
    google: 'Google',
    no_account: 'ليس لديك حساب؟',
    have_account: 'لديك حساب بالفعل؟',
    create_account: 'إنشاء حساب جديد',
    full_name: 'الاسم الكامل',
    username: 'اسم المستخدم',
    email: 'البريد الإلكتروني',
    phone: 'رقم الهاتف',
    confirm_password: 'تأكيد كلمة المرور',
    agree_terms: 'أوافق على شروط الخدمة وسياسة الخصوصية',
    reset_password: 'إعادة تعيين كلمة المرور',
    send_code: 'إرسال رمز التحقق',
  },

  // Dashboard Screen
  dashboard: {
    greeting: 'مرحبًا',
    grow_subtitle: 'نمّ حساباتك الاجتماعية اليوم مع تسليم فوري ومستقر',
    current_balance: 'الرصيد الحالي',
    your_balance: 'رصيدك',
    add_funds: '+ شحن الرصيد',
    quick_actions: 'إجراءات سريعة',
    services_catalog: 'دليل الخدمات',
    order_now: 'طلب جديد',
    track_orders: 'متابعة الطلبات',
    wallet_topup: 'شحن المحفظة',
    popular_services: 'الخدمات الشائعة',
    recent_orders: 'أحدث الطلبات',
    recent_subtitle: 'تتبع طلباتك الأخيرة وحالة التسليم المباشرة',
    no_orders_yet: 'لا توجد طلبات بعد',
    no_orders_desc: 'اختر خدمة من دليل الخدمات لتعزيز حساباتك اليوم.',
    place_first_order: 'إنشاء أول طلب',
    social_media_services: 'خدمات السوشيال ميديا',
    social_media_subtitle: 'زيادة المتابعين والإعجابات والمشاهدات',
    virtual_numbers: 'أرقام وهمية',
    virtual_numbers_subtitle: 'احصل على أرقام لتفعيل الحسابات وتلقي الرموز',
    popular_social_media_services: 'أبرز خدمات السوشيال ميديا',
    popular_virtual_numbers: 'الأرقام الوهمية الأكثر طلباً',
    fast_and_reliable: 'تنفيذ سريع وتلقائي',
    fast_and_reliable_sub: 'تبدأ جميع الطلبات بالمعالجة تلقائياً خلال ثوانٍ معدودة.',
    total_orders: 'إجمالي الطلبات',
    all_time_completed: 'المكتملة كلياً',
    total_spent: 'إجمالي المدفوعات',
    lifetime_volume: 'إجمالي الاستخدام',
    vn_used: 'أرقام وهمية مستخدمة',
    sms_verifications: 'رموز SMS المستلمة',
    see_all_services: 'عرض كل الخدمات',
    browse_countries: 'تصفح جميع الدول',
    view_all_orders: 'عرض جميع الطلبات ←',
  },

  // Services Screen
  services: {
    title: 'الخدمات',
    subtitle: 'اختر من بين أكثر من 500 باقة لتعزيز حضورك على المنصات.',
    promo_title: 'نمِّ حساباتك على وسائل التواصل بأسرع وقت',
    promo_subtitle: 'احصل على متابعين وإعجابات ومشاهدات بأسعار الجملة المعتمدة مع تسليم تلقائي.',
    quick_order: 'طلب سريع',
    show_all_platforms: 'عرض جميع المنصات',
    search_placeholder: 'ابحث بالاسم أو الفئة أو المعرف (مثال: TikTok, Instagram, 1024)...',
    all_categories: 'جميع الفئات',
    popular_packages: 'الباقات المميزة',
    buy_now: 'شراء الآن',
    order: 'طلب',
    min: 'الحد الأدنى',
    max: 'الحد الأقصى',
    per_1k: 'لكل 1,000',
    instant_delivery: 'تسليم فوري',
    high_retention: 'ثبات عالي',
    safe_secure: 'آمن ومضمون 100%',
    no_services_found: 'لم يتم العثور على أي خدمات تطابق بحثك.',
    social_media_tab: 'السوشيال ميديا',
    virtual_numbers_tab: 'أرقام وهمية',
    favorites: 'المفضلة',
    all_platforms: 'كل المنصات',
    grid_view: 'بطاقات',
    table_view: 'جدول',
  },

  // Virtual Numbers
  virtual_numbers: {
    title: 'أرقام وهمية',
    subtitle: 'أرقام مؤقتة ومستأجرة لتفعيل الحسابات واستقبال رسائل التفعيل SMS.',
    promo_title: 'أرقام افتراضية خاصة لجميع المنصات',
    promo_desc: 'أرقام مؤقتة لتفعيل الحسابات على التطبيقات والمواقع مع استقبال فوري لرسائل SMS.',
    buy_number: 'شراء رقم',
    orders: 'الطلبات',
    rents: 'استئجار رقم',
    my_numbers: 'أرقامي',
    instant_delivery: 'تسليم فوري',
    wide_selection: 'خيارات واسعة من الدول',
    affordable_prices: 'أسعار مناسبة',
    popular_countries: 'الدول الشائعة',
    popular_services: 'الخدمات الشائعة',
    select_country: 'اختر الدولة',
    select_service: 'اختر الخدمة',
    choose_number: 'اختر الرقم',
    order_summary: 'ملخص الطلب',
    step_payment: 'الدفع',
    continue_payment: 'المتابعة إلى الدفع',
    number_activated: 'تم تفعيل الرقم',
    number_ready: 'رقمك الافتراضي جاهز للاستخدام الآن.',
    time_remaining: 'الوقت المتبقي',
    received_codes: 'الرموز المستلمة',
    no_codes_yet: 'لا توجد رموز بعد',
    codes_auto_appear: 'ستظهر رموز التفعيل المستلمة لهذا الرقم هنا تلقائياً.',
    instructions_text: 'افتح التطبيق وأدخل هذا الرقم لتلقي كود التفعيل. ستظهر الرموز تلقائياً.',
    extend: 'تمديد',
    rent_again: 'استئجار مجدداً',
    cancel: 'إلغاء',
    all_codes: 'جميع الرموز',
    unread: 'غير مقروءة',
    available: 'متاح',
    refresh: 'تحديث',
    phone_number: 'رقم الهاتف',
    view_all: 'عرض الكل >',
    select_provider: 'اختر المزود',
    live_rates: 'الأسعار المباشرة',
    choose_provider_sub: 'اختر مزود الأرقام الافتراضية المفضل لديك:',
    instant_sms_desc: 'تفعيل فوري لرسائل SMS',
    global_pool_desc: 'تغطية عالمية ومجموعة أرقام واسعة',
    country: 'الدولة',
    service: 'الخدمة',
    provider: 'المزود',
    price: 'السعر',
    auto_assigned: 'يتم تعيينه تلقائياً عند الشراء',
    pay_activate_btn: 'دفع وتفعيل الرقم',
    number_details: 'تفاصيل الرقم',
    number_details_sub: 'تم تفعيل رقمك بنجاح. استخدمه الآن لتلقي رموز التفعيل.',
    waiting_for_code: 'في انتظار وصول كود التفعيل SMS...',
    instructions: 'التعليمات',
    instructions_prefix: 'افتح',
    instructions_suffix: 'وأدخل هذا الرقم لتلقي كود التفعيل.',
    view_all_received_codes: 'عرض كل الرموز المستلمة ←',
    search_service_placeholder: 'ابحث عن خدمة (واتساب، تيليجرام...)',
    search_country_placeholder: 'ابحث عن دولة...',
    no_services_found: 'لم يتم العثور على خدمات',
    no_countries_found: 'لم يتم العثور على دول',
    no_numbers_yet: 'لا توجد أرقام بعد',
    no_numbers_sub: 'عند شراء رقم وهمي، سيظهر هنا مباشرة.',
    buy_a_number: 'شراء رقم جديد',
    my_rents: 'إيجاراتي',
    my_rents_sub: 'إدارة أرقامك المستأجرة وتمديد فترة الإيجار ومتابعة حالتها.',
    search_rent_placeholder: 'ابحث برقم أو خدمة أو دولة...',
    active: 'نشط',
    expiring: 'قريب الانتهاء',
    expired: 'منتهي',
    all: 'الكل',
    back_to_services: '‹ العودة إلى كل الخدمات',
    back_to_countries: '‹ العودة إلى الدول',
    select_country_continue: 'اختر دولة لإتمام عملية الشراء',
    success_rate: 'نسبة النجاح',
    confirm_purchase_title: 'تأكيد شراء الرقم',
    confirm_purchase_sub: 'تأكد من تفاصيل طلبك قبل تفعيل الرقم الوهمي.',
    total_deducted: 'المبلغ المخصوم',
    your_new_balance: 'رصيدك بعد الشراء',
    insufficient_balance: 'رصيدك غير كافٍ لشراء هذا الرقم.',
    deposit_to_continue: 'يرجى شحن رصيد المحفظة للمتابعة.',
  },

  // New Order Screen
  new_order: {
    title: 'طلب جديد',
    subtitle: 'أدخل رابط الحساب أو المنشور والكمية المطلوبة للبدء.',
    service_selected: 'الخدمة المختارة',
    category_label: 'الفئة',
    select_category: 'اختر الفئة',
    service_label: 'الخدمة',
    select_service: 'اختر الخدمة',
    link_label: 'رابط الحساب / الرابط المستهدف',
    link_placeholder: 'مثال: https://instagram.com/username أو رابط منشور',
    link_helper: 'تأكد من أن الحساب أو المنشور عام (Public) وليس خاصاً',
    quantity_label: 'الكمية',
    min_max: 'الحد الأدنى: {min} — الحد الأقصى: {max}',
    total_price: 'المبلغ الإجمالي',
    place_order_btn: 'تأكيد الطلب الآن',
    order_success_title: 'تم إنشاء الطلب بنجاح!',
    order_success_sub: 'طلبك قيد المعالجة وسيبدأ تنفيذه في غضون ثوانٍ.',
    order_id: 'رقم الطلب',
    track_orders_btn: 'متابعة في الطلبات',
    back_to_services_btn: 'العودة للخدمات',
    comments_label: 'تعليقات مخصصة',
    comments_placeholder: 'أدخل تعليقاً واحداً في كل سطر...',
    comments_badge: '{count} تعليق',
    rate_per_1k: 'السعر / 1,000',
    delivery_time: 'وقت التنفيذ',
    service_description: 'وصف الخدمة',
    quick_presets: 'كميات سريعة',
    insufficient_balance: 'الرصيد غير كافٍ',
    insufficient_sub: 'رصيد محفظتك غير كافٍ لإتمام هذا الطلب.',
    deposit_now: 'شحن الرصيد الآن',
    order_summary: 'ملخص الطلب',
  },

  // Orders Screen
  orders: {
    title: 'طلباتي',
    subtitle: 'تتبع حالة تنفيذ طلباتك بشكل مباشر وفوري.',
    search_placeholder: 'بحث برقم الطلب أو اسم الخدمة أو الرابط...',
    filter_all: 'جميع الطلبات',
    filter_pending: 'قيد الانتظار',
    filter_progress: 'قيد التنفيذ',
    filter_completed: 'مكتملة',
    filter_partial: 'جزئية',
    filter_cancelled: 'ملغاة',
    no_orders_found: 'لم يتم العثور على طلبات تطابق هذا التصنيف.',
    progress: 'نسبة الإنجاز',
    view_cards: 'بطاقات',
    view_table: 'جدول',
    order_num: 'الطلب',
    service_col: 'الخدمة',
    quantity_col: 'الكمية',
    cost_col: 'التكلفة',
    status_col: 'الحالة',
    date_col: 'التاريخ',
    link_col: 'الرابط',
    copy_link: 'نسخ الرابط',
    open_link: 'فتح الرابط',
  },

  // Wallet / Deposit Screen
  wallet: {
    title: 'المحفظة',
    subtitle: 'اشحن رصيدك بكل سهولة وأمان لإنشاء الطلبات بسرعة.',
    current_balance: 'الرصيد المتاح',
    add_funds: 'شحن الرصيد',
    transaction_history: 'سجل المعاملات',
    select_amount: 'اختر المبلغ',
    custom_amount: 'مبلغ مخصص',
    enter_amount_placeholder: 'أدخل المبلغ (مثال: 5000)',
    select_payment_method: '1. اختر طريقة الدفع',
    phone_number: 'رقم الهاتف',
    proceed_to_payment: 'المتابعة إلى الدفع',
    secure_payments: 'عمليات دفع مشفرة وآمنة تماماً.',
    instant_addition: 'تتم إضافة الرصيد إلى محفظتك فور تأكيد الدفع.',
    recent_transactions: 'أحدث المعاملات',
    bonus_title: 'تم تفعيل بونص الإيداع الأول!',
    bonus_desc: 'احصل على رصيد إضافي يضاف إلى محفظتك مباشرة عند إيداعك الأول!',
    quick_amounts: 'مبالغ سريعة',
    one_tap_fill: 'بنقرة واحدة',
    amount_in: 'المبلغ بعملة {currency}',
    depositing: 'المبلغ المراد إيداعه',
    credited_to_wallet: 'المبلغ المضاف للمحفظة',
    no_transactions: 'لا توجد معاملات بعد',
    no_transactions_sub: 'ستظهر عمليات الإيداع والاسترداد هنا فور معالجتها.',
    pay_now: 'ادفع الآن',
  },

  // Settings Screen
  settings: {
    title: 'إعدادات الحساب',
    subtitle: 'إدارة تفضيلات الحساب، العملة الإقليمية، كلمة المرور ووصول API.',
    tab_preferences: 'التفضيلات والعملة',
    tab_security: 'الأمان وكلمة المرور',
    tab_api: 'مفتاح API والموزع',
    loc_title: 'الموقع الجغرافي والعملة واللغة',
    loc_subtitle: 'حدد دولتك ولغتك المفضلة وعملة الحساب للطلبات والدفع.',
    field_country: 'الدولة الرئيسية',
    field_country_desc: 'ستعتمد خيارات الدفع المحلية والدفع عبر الهاتف على هذه الدولة تلقائياً.',
    field_currency: 'عملة عرض الحساب',
    field_language: 'اللغة المفضلة',
    field_language_desc: 'اختر لغة عرض الواجهة والإشعارات.',
    btn_save_preferences: 'حفظ التفضيلات',
    btn_saving_preferences: 'جارٍ التحديث...',
    msg_preferences_saved: 'تم تحديث التفضيلات بنجاح!',
    security_title: 'تغيير كلمة المرور',
    security_sub: 'احمِ حسابك باستخدام كلمة مرور قوية وغير مكررة.',
    current_password: 'كلمة المرور الحالية',
    new_password: 'كلمة المرور الجديدة',
    confirm_new_password: 'تأكيد كلمة المرور الجديدة',
    btn_update_password: 'تحديث كلمة المرور',
    api_title: 'وصول API للموزعين',
    api_sub: 'اربط خدمات NiceBooster مباشرة بتطبيقك الخاص أو لوحة SMM الخاصة بك.',
    api_key_label: 'مفتاح API السري الخاص بك',
    generate_key: 'توليد مفتاح جديد',
    copy_key: 'نسخ المفتاح',
    reseller_status: 'حالة وصول الموزع',
  },

  // Support Screen
  support: {
    title: 'المساعدة والدعم',
    subtitle: 'تواصل مع فريق الدعم الفني المتوفر على مدار الساعة 24/7.',
    whatsapp_chat: 'محادثة عبر واتساب',
    whatsapp_desc: 'الرد الأسرع — متوسط الرد في أقل من 5 دقائق',
    telegram_chat: 'دعم تيليجرام',
    telegram_desc: 'مساعدة فورية من فريق الدعم المتخصص',
    email_support: 'الدعم عبر البريد',
    email_desc: 'للاستفسارات العامة أو الشراكات التجارية',
  },

  // Landing Page
  landing: {
    hero_title_1: 'نمِّ حساباتك على وسائل التواصل بـ',
    hero_title_2: 'أسعار الجملة',
    hero_subtitle: 'المنصة الآلية المتكاملة لصناع المحتوى والشركات والوكالات الإعلانية. زيادة المتابعين والإعجابات والمشاهدات والحصول على أرقام وهمية لتفعيل الحسابات.',
    hero_cta_free: 'ابدأ مجاناً الآن',
    hero_view_catalog: 'دليل الخدمات والأسعار',
    hero_trusted: 'موثوق من أكثر من 50,000 صانع محتوى • دعم الدفع عبر الهاتف والعملات الرقمية',
    stat_delivered_today: 'الطلبات المنجزة اليوم',
    stat_sms_received: 'رسائل SMS المستلمة',
    stat_orders_completed: 'إجمالي الطلبات المكتملة',
    stat_active_creators: 'صناع محتوى ووكالات نشطة',
    stat_uptime: 'جاهزية النظام الآلي',
    stat_speed: 'متوسط سرعة بدء الطلب',
    live_order_network: 'شبكة الطلبات المباشرة',
    recent_activity: 'النشاط الأخير',
    final_cta_title: 'عزز تواجدك الرقمي اليوم بكل ثقة',
    final_cta_subtitle: 'انضم إلى أكثر من 50,000 عميل وشركة ينمون بسهولة مع NiceBooster.',
    create_free_account: 'إنشاء حساب مجاني',
    talk_to_support: 'تحدث مع الدعم الفني',
    footer_nav: 'التنقل',
    footer_account: 'الحساب',
    footer_support: 'الدعم والقانوني',
  },

  // Flat keys for backwards compatibility
  nav_dashboard: 'لوحة التحكم',
  nav_new_order: 'طلب جديد',
  nav_services: 'الخدمات',
  nav_orders: 'الطلبات',
  nav_deposit: 'شحن الرصيد',
  nav_virtual_numbers: 'أرقام وهمية',
  nav_referrals: 'برنامج الإحالة',
  nav_settings: 'الإعدادات',
  nav_support: 'الدعم الفني',
  nav_guide: 'دليل الاستخدام',
  nav_logout: 'تسجيل الخروج',
  nav_login: 'تسجيل الدخول',
  nav_signup: 'إنشاء حساب',
  nav_features: 'المميزات',
  nav_platforms: 'المنصات',
  nav_how_it_works: 'كيف يعمل',
  nav_pricing: 'الأسعار',
  nav_faq: 'الأسئلة الشائعة',
  nav_language: 'اللغة',
  settings_title: 'إعدادات الحساب',
  settings_subtitle: 'إدارة تفضيلات الحساب، العملة الإقليمية، كلمة المرور ووصول API.',
  tab_preferences: 'التفضيلات والعملة',
  tab_security: 'الأمان وكلمة المرور',
  tab_api: 'مفتاح API والموزع',
  loc_title: 'الموقع الجغرافي والعملة واللغة',
  loc_subtitle: 'حدد دولتك ولغتك المفضلة وعملة الحساب للطلبات والدفع.',
  field_country: 'الدولة الرئيسية',
  field_country_desc: 'ستعتمد خيارات الدفع المحلية والدفع عبر الهاتف على هذه الدولة تلقائياً.',
  field_currency: 'عملة عرض الحساب',
  field_language: 'اللغة المفضلة',
  field_language_desc: 'اختر لغة عرض الواجهة والإشعارات.',
  btn_save_preferences: 'حفظ التفضيلات',
  btn_saving_preferences: 'جارٍ التحديث...',
  msg_preferences_saved: 'تم تحديث التفضيلات بنجاح!',
  dash_smm_services: 'خدمات السوشيال ميديا',
  dash_smm_desc: 'زيادة المتابعين والإعجابات والمشاهدات في جميع المنصات',
  dash_vn_title: 'أرقام وهمية',
  dash_vn_desc: 'احصل على أرقام لتفعيل الحسابات وتلقي الرموز فورا',
  dash_popular_smm: 'أبرز خدمات السوشيال ميديا',
  dash_see_all_services: 'عرض كل الخدمات',
  dash_popular_vn: 'الأرقام الوهمية الأكثر طلباً',
  dash_browse_countries: 'تصفح جميع الدول',
  dash_top_up: '+ شحن الرصيد',
  dash_total_orders: 'إجمالي الطلبات',
  dash_all_time_completed: 'المكتملة كلياً',
  dash_total_spent: 'إجمالي المدفوعات',
  dash_lifetime_volume: 'إجمالي الاستخدام',
  dash_vn_used: 'أرقام وهمية مستخدمة',
  dash_sms_verifications: 'رموز SMS المستلمة',
  dash_recent_orders: 'أحدث الطلبات',
  dash_recent_subtitle: 'تتبع طلباتك الأخيرة وحالة التسليم المباشرة',
  dash_refresh: 'تحديث',
  dash_view_all_orders: 'عرض جميع الطلبات ←',
  col_order: 'الطلب',
  col_service: 'الخدمة',
  col_quantity: 'الكمية',
  col_cost: 'التكلفة',
  col_status: 'الحالة',
  col_date: 'التاريخ',
  no_orders_placed: 'لا توجد طلبات بعد',
  no_orders_desc: 'اختر خدمة من دليل الخدمات لتعزيز حساباتك اليوم.',
  place_first_order: 'إنشاء أول طلب',
  hero_title_1: 'نمِّ حساباتك على وسائل التواصل بـ',
  hero_title_2: 'أسعار الجملة',
  hero_subtitle: 'المنصة الآلية المتكاملة لصناع المحتوى والشركات والوكالات الإعلانية. زيادة المتابعين والإعجابات والمشاهدات والحصول على أرقام وهمية لتفعيل الحسابات.',
  hero_cta_free: 'ابدأ مجاناً الآن',
  hero_view_catalog: 'دليل الخدمات والأسعار',
  hero_trusted: 'موثوق من أكثر من 50,000 صانع محتوى • دعم الدفع عبر الهاتف والعملات الرقمية',
  stat_delivered_today: 'الطلبات المنجزة اليوم',
  stat_sms_received: 'رسائل SMS المستلمة',
  stat_orders_completed: 'إجمالي الطلبات المكتملة',
  stat_active_creators: 'صناع محتوى ووكالات نشطة',
  stat_uptime: 'جاهزية النظام الآلي',
  stat_speed: 'متوسط سرعة بدء الطلب',
  live_order_network: 'شبكة الطلبات المباشرة',
  recent_activity: 'النشاط الأخير',
  final_cta_title: 'عزز تواجدك الرقمي اليوم بكل ثقة',
  final_cta_subtitle: 'انضم إلى أكثر من 50,000 عميل وشركة ينمون بسهولة مع NiceBooster.',
  create_free_account: 'إنشاء حساب مجاني',
  talk_to_support: 'تحدث مع الدعم الفني',
  footer_nav: 'التنقل',
  footer_account: 'الحساب',
  footer_support: 'الدعم والقانوني',
  available_balance: 'الرصيد المتاح',
  add_funds: 'شحن الرصيد',
  place_order: 'إنشاء الطلب',
  category: 'الفئة',
  service: 'الخدمة',
  quantity: 'الكمية',
  link: 'الرابط',
  total_cost: 'التكلفة الإجمالية',
  status: 'الحالة',
  actions: 'إجراءات',
  search: 'بحث',
  cancel: 'إلغاء',
  loading: 'جارٍ التحميل...',
  close: 'إغلاق',
};
